/* eslint-disable */
"use client";

import { FC, forwardRef } from "react";
import classNames from "classnames";
import Tooltip from "../../(components)/ToolTip";

type Props = {
  id: string;
  label?: string;
  className?: string;
  landingFontWeight?: boolean;
  landingFontColor?: boolean;
  landingBorderColor?: boolean;
  withError?: boolean;
  error: any;
  type?: string;
  autoComplete?: string;
  required?: boolean;
  disabled?: boolean;
  disabledText?: string;
  tooltipId?: string;
  placeholder?: string;
  maxDateDay?: string;
  t?: any;
};

export const Label = (props: {
  label: string | undefined;
  htmlFor: string;
  landingFontWeight: boolean | undefined;
  landingFontColor: boolean | undefined;
  required?: boolean | undefined;
  error: any;
}) => {
  return (
    <>
      {props.label ? (
        <label htmlFor={props.htmlFor} className="block mb-3">
          <span
            className={classNames("text-sm font-semibold", {
              "font-medium": props.landingFontWeight,
              "text-neutral-900": props.landingFontColor,
              "text-[#031F47]": !props.landingFontColor,
            })}
          >
            {props.label}
          </span>
          {props.required ? (
            <span
              className={classNames("pl-1", {
                "text-neutral-100": !props.error,
                "text-red-500": props.error,
              })}
            >
              *
            </span>
          ) : (
            ""
          )}
        </label>
      ) : (
        ""
      )}
    </>
  );
};

const Field: FC<Props> = forwardRef(
  (
    {
      id,
      label,
      className,
      placeholder,
      landingFontWeight,
      landingFontColor,
      landingBorderColor,
      error,
      required,
      withError,
      disabled,
      disabledText,
      tooltipId,
      t,
      type = "string",
      ...rest
    }: Props,
    ref: any,
  ) => {
    return (
      <div className={className}>
        <Label
          label={label}
          htmlFor={id}
          landingFontWeight={landingFontWeight}
          landingFontColor={landingFontColor}
          required={required}
          error={error}
        />

        <div>
          {disabled ? (
            <Tooltip content={disabledText} direction="bottom">
              <input
                ref={ref}
                {...rest}
                type={type}
                id={id}
                disabled={disabled}
                placeholder={placeholder}
                className={classNames(
                  `block w-full appearance-none rounded-lg border px-3 py-[13px] leading-[140%] font-medium focus:outline-none text-sm ${className} `,
                  {
                    "border-red-500 focus:border-red-500 focus:ring-red-500":
                      error || withError,
                    "border-neutral-400 focus:border-primary-800 focus:ring-primary-800":
                      !error,
                    "cursor-pointer text-neutral-500": disabled,
                  },
                )}
              />
            </Tooltip>
          ) : (
            <input
              ref={ref}
              {...rest}
              type={type}
              id={id}
              // disabled={disabled}
              placeholder={placeholder}
              className={classNames(
                `block w-full appearance-none rounded-lg border px-3 py-[13px] leading-[140%] font-medium focus:outline-none text-sm ${className} `,
                {
                  "border-red-500 focus:border-red-500 focus:ring-red-500":
                    error,
                  "border-neutral-400 focus:border-primary-800 focus:ring-primary-800":
                    !error,
                  "cursor-pointer text-neutral-500": disabled,
                },
              )}
            />
          )}

          {error && (
            <span className="text-red-500 text-xs">
              {t ? t(error.message) : error.message}
            </span>
          )}
        </div>
      </div>
    );
  },
);

export { Field };

const FieldRow: FC<Props> = forwardRef(
  (
    {
      id,
      label,
      className,
      placeholder,
      error,
      required,
      withError,
      disabled,
      disabledText,
      tooltipId,
      t,
      type = "string",
      ...rest
    }: Props,
    ref: any,
  ) => {
    return (
      <div className="flex flex-col sm:flex-row justify-between items-center px-6 py-2 bg-slate-50">
        <label htmlFor={id} className="text-neutral-500 text-b2 font-medium">
          {label}
        </label>
        <div>
          <div>
            {disabled ? (
              <Tooltip content={disabledText} direction="bottom">
                <input
                  ref={ref}
                  {...rest}
                  type={type}
                  id={id}
                  disabled={disabled}
                  placeholder={placeholder}
                  className={classNames(
                    `block w-full appearance-none rounded-lg border px-3 py-[13px] leading-[140%] font-medium  focus:outline-none text-sm ${className} `,
                    {
                      "border-red-500 focus:border-red-500 focus:ring-red-500":
                        error || withError,
                      "border-neutral-400 focus:border-primary-800 focus:ring-primary-800":
                        !error,
                      "cursor-pointer text-neutral-500": disabled,
                    },
                  )}
                />
              </Tooltip>
            ) : (
              <input
                ref={ref}
                {...rest}
                type={type}
                id={id}
                // disabled={disabled}
                placeholder={placeholder}
                className={classNames(
                  `block w-full appearance-none rounded-lg border px-3 py-[13px] leading-[140%] font-medium  focus:outline-none text-sm ${className} `,
                  {
                    "border-red-500 focus:border-red-500 focus:ring-red-500":
                      error,
                    "border-neutral-400 focus:border-primary-800 focus:ring-primary-800":
                      !error,
                    "cursor-pointer text-neutral-500": disabled,
                  },
                )}
              />
            )}

            {error && (
              <span className="text-red-500 text-xs">
                {t ? t(error.message) : error.message}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  },
);

export { FieldRow };
